import PhotoSwipeLightbox from 'photoswipe-lightbox';
import PhotoSwipe from 'photoswipe';

function init() {
  const gallery = document.querySelector('product-gallery');
  if (!gallery) return;

  // Double rAF: wait for Swiper (product-gallery.js) to finish its own
  // requestAnimationFrame and create loop-clone slides.
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      // Build slide data from real slides only (exclude Swiper loop clones).
      const realSlides = [
        ...gallery.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)'),
      ];
      if (!realSlides.length) return;

      const dataSource = realSlides.map((slide) => {
        const img = slide.querySelector('img');
        if (!img) return null;

        const nw = img.naturalWidth  || parseInt(img.getAttribute('width'),  10) || 640;
        const nh = img.naturalHeight || parseInt(img.getAttribute('height'), 10) || 800;

        // Request a high-res version from the Shopify CDN by bumping the height param.
        const highResHeight = 3840;
        const highResWidth  = Math.round(nw * (highResHeight / nh));
        const src = img.src.replace(/height=\d+/, `height=${highResHeight}`);

        return { src, width: highResWidth, height: highResHeight, msrc: img.src, alt: img.alt };
      }).filter(Boolean);

      const lightbox = new PhotoSwipeLightbox({
        dataSource,
        pswpModule: PhotoSwipe,
        bgOpacity: 0.9,
        showHideAnimationType: 'zoom',
      });
      lightbox.init();

      // Click delegation — works on both real slides and Swiper loop clones.
      // Swiper sets data-swiper-slide-index on every slide (including clones)
      // to the index of the original slide it mirrors.
      gallery.addEventListener('click', (e) => {
        if (!e.target.closest('img')) return;
        const slide = e.target.closest('.swiper-slide');
        if (!slide) return;
        e.preventDefault();
        const index = parseInt(slide.dataset.swiperSlideIndex, 10) || 0;
        lightbox.loadAndOpen(index);
      });
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
